//
// This is the client side entry point for the React app.
//
import React from 'react';
import { routes } from './routes';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import rootReducer from './root-reducer';
import thunkMiddleware from 'redux-thunk';
import { browserHistory } from 'react-router';
import { ClientAuthMiddleware, isServerSide } from 'doctify-utils';
import { routerMiddleware } from 'react-router-redux';
import { createStore, applyMiddleware, compose } from 'redux';

import 'bootstrap-sass/assets/stylesheets/_bootstrap.scss';
import 'ionicons/scss/ionicons.scss';
import 'assets';

const initialState = window.__PRELOADED_STATE__;
const composeEnhancers = !isServerSide() &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        actionSanitizer: (action) => {
            if (
                (
                    action.type.indexOf('LISTINGS:') === 0 &&
                    action.type.indexOf('RECEIVED') !== -1
                ) ||
                (
                    action.type.indexOf('LANDING_PAGES_RECEIVED') !== -1
                )
            ) {
                const response = (Array.isArray(action.response) && [{ 'BIG': 'DATA' }]) || (typeof action.response === 'object' && { 'BIG': 'DATA' });
                return {
                    ...action,
                    response
                };
            } else if (
                action.type.indexOf('SEARCH_BAR_TABS:SET_LOCATION_INPUT_FIELD') !== -1 ||
                action.type.indexOf('SEARCH_ACTIONS:UDPATE_MARKERS') !== -1 ||
                action.type.indexOf('SEARCH_ACTIONS:SET_LOCATION_INPUT_FIELD') !== -1
            ) {
                return {
                    ...action,
                    payload: { 'BIG': 'DATA' }
                };
            }
            return action;
        },
        stateSanitizer: (state) => {
            const copyObject = (origin) => {
                const copy = {};
                Object.keys(origin).forEach(key => {
                    copy[key] = (Array.isArray(origin[key]) && [{ 'BIG': 'DATA' }]) || (typeof origin[key] === 'object' && { 'BIG': 'DATA' }) || 'BIG DATA';
                });
                return copy;
            };

            const { listings, ...global } = state.global;
            const { landingPages, ...home } = state.home;

            const { page: stateSearchPage, results: stateSearchResults, advancedSearchBar: stateSearchAdvancedSearchBar } = state.search;
            const { insurersDropdownElem, ...page } = stateSearchPage;
            const { markers, ...results } = stateSearchResults;
            const { locationInputField: ASBLocationInputField, ...advancedSearchBar} = stateSearchAdvancedSearchBar;

            const { locationInputField, ...searchBarTabs } = home.searchBarTabs;

            const shortListings = copyObject(listings);
            const shortLandingPages = copyObject(landingPages);
            const shortLocationInputField = { 'BIG': 'DATA' };

            return {
                ...state,
                global: {
                    ...global,
                    listings: shortListings
                },
                home: {
                    ...home,
                    landingPages: shortLandingPages,
                    searchBarTabs: {
                        ...searchBarTabs,
                        shortLocationInputField
                    }
                },
                search: {
                    advancedSearchBar: {
                        ...advancedSearchBar
                    },
                    page: {
                        ...page
                    },
                    results: {
                        ...results
                    }
                }
            };
        }
    }) ||
    compose;

const store = createStore(
	rootReducer, initialState,
	composeEnhancers(
		applyMiddleware(
			thunkMiddleware, ClientAuthMiddleware, routerMiddleware(browserHistory)
		)
	)
);

if (typeof document !== 'undefined') {
	const root = document.createElement('div');
	document.body.appendChild(root);
	// ReactDOM.render(<App />, root);
}



render(
	<Provider store={store}>
		{ routes(store) }
	</Provider>,
	document.querySelector('.js-content')
);



// WEBPACK FOOTER //
// ./src/client/app.jsx